module.exports = {
          srcSet: __webpack_public_path__ + "25e999fa1e875183ae85c238973442ee-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "25e999fa1e875183ae85c238973442ee-1168.png",width: 1168,height: 234}],
          src: __webpack_public_path__ + "25e999fa1e875183ae85c238973442ee-1168.png",
          toString:function(){return __webpack_public_path__ + "25e999fa1e875183ae85c238973442ee-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AFdoUP1seV3/ZHlf/l98Zf9RdWL/U2Va/3pGQ/9fWUv+WHJW/zhcSvsARl5H+19tUP9RaFD+Q2JQ/ydaR/9oSkP/lkpK/0VSRP5AW0P/MFdG+ZNnKFZ11tbOAAAAAElFTkSuQmCC",
          width: 1168,
          height: 234
        }